module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/regenerator/index.js
// module id = ./node_modules/@babel/runtime/regenerator/index.js
// module chunks = 0